import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const DrumConfiguration = ({ onDrumConfigurationSelected }) => {
  const [selectedDrumConfiguration, setSelectedDrumConfiguration] =
    useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.drumconfiguration) {
        const drumConfigurationObject = firstResult.drumconfiguration;
        if (drumConfigurationObject.trim() !== "") {
          setVariations(drumConfigurationObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleDrumConfigurationClick = (drumconfiguration) => {
    setSelectedDrumConfiguration(drumconfiguration);
    onDrumConfigurationSelected(drumconfiguration);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Drum Configuration:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedDrumConfiguration === variation ? "selected" : ""}`}
            onClick={() => handleDrumConfigurationClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default DrumConfiguration;
